import ScrollAnimation from 'react-animate-on-scroll';
import Grid from "@material-ui/core/Grid";
import React from "react";
import '../css/landing-info.css';
import Typing from "react-typing-animation";

const LandingInfo = () => (
    <div className="landing-screen" style={{width: '100%', margin: 'auto'}}>
        {/*Landing information*/}
        <br/>
        <br/>
        <ScrollAnimation animateIn='fadeInDown' animateOut='fadeOutUp'>
            <Grid xs={12}>
                <img src="https://avatars0.githubusercontent.com/u/48325651?s=460&v=4" alt="avatar"
                     className="avatar"/>
                <br/>
            </Grid>
            <Grid className="position">
                <Grid xs={3}/>
                <Grid xs={6} className="info-box-cell">
                    <br/>
                    <Typing cursorClassName="cursor">
                        <h2>Marcel Mendes</h2>
                        <Typing.Speed ms={25}/>
                        <h2>Student at Loughborough University</h2>
                    </Typing>

                    <div className="icons-social-media">
                        <a href="https://github.com/devmarcy">
                            <i className="fab fa-github fa-3x fa-fw"/>
                        </a>
                        <a href="https://stackoverflow.com/users/11452576/devmarcy">
                            <i className="fab fa-stack-overflow fa-3x fa-fw"/>
                        </a>
                        <a href="https://www.linkedin.com/in/marcelmendes17">
                            <i className="fab fa-linkedin fa-3x fa-fw"/>
                        </a>
                        <a href="mailto:marcelmendes@hotmail.co.uk">
                            <i className="fas fa-at fa-3x fa-fw"/>
                        </a>
                    </div>
                    <p> | Python | Java | HTML | Javascript | CSS | PHP |</p>
                    <br/>
                </Grid>
                <Grid xs={3}/>
            </Grid>
        </ScrollAnimation>
    </div>
);
export default LandingInfo;
